import { Icon, Tooltip } from "@material-ui/core";
import * as React from "react";
import styles from "./Chip.scss";

interface IProps {
    path: string[];
    tooltip?: string;
    className?: string;
    wrapperClassName?: string;
    size?: string;
}

const Chip: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={`${styles.chip} ${props.className} ${props.size && styles[props.size]}`}>
        <Tooltip title={props.tooltip} aria-label={props.tooltip}>
            <div className={`${styles.wrapper} ${props.wrapperClassName}`}>
                {
                    props.path.map((text: string, index: number) => {
                        const icon = index !== 0 && <Icon key={`icon_${index}`} className={styles.icon}>arrow_right_alt</Icon>;
                        return [
                            icon, <span key={`label_${index}`}>{text}</span>
                        ];
                    })
                }
            </div>
        </Tooltip>
    </div>
);

export default Chip;


// WEBPACK FOOTER //
// ./src/Components/Common/Chip/Chip.tsx